import { render } from "./SuKwsMarketIcon.vue?vue&type=template&id=452f2426"
import script from "./SuKwsMarketIcon.vue?vue&type=script&lang=js"
export * from "./SuKwsMarketIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__